import trashCan from "images/trash-can.svg";
import styles from "./TrashCanButton.module.css";

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  onRemove: () => void;
  size?: "sm" | "md" | "lg";
}

export const TrashCanButton: React.FC<IProps> = ({ onRemove, onClick, ...props }) => {
  const handleClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
    if (onClick) {
      onClick(e);
    }
  };

  const size = `icon-${props.size || "md"}`;

  return (
    <div className={`${styles.button} ${size}`}>
      <img src={trashCan} alt="delete" onClick={handleClick} {...props} />
    </div>
  );
};
